import { render } from "./CheckBox.vue?vue&type=template&id=742c6562&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=742c6562&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742c6562"]])

export default __exports__